import { render, staticRenderFns } from "./MAM007-visualizarMovimientos.vue?vue&type=template&id=2ff086e8&scoped=true&"
import script from "./MAM007-visualizarMovimientos.vue?vue&type=script&lang=js&"
export * from "./MAM007-visualizarMovimientos.vue?vue&type=script&lang=js&"
import style0 from "./MAM007-visualizarMovimientos.vue?vue&type=style&index=0&id=2ff086e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff086e8",
  null
  
)

export default component.exports